<template>
  <svg
    xmlns="http://www.w3.org/2000/svg" width="18.081"
    height="14.807" viewBox="0 0 18.081 14.807"
  >
    <g
      id="그룹_78" data-name="그룹 78"
      transform="translate(0 14.807) rotate(-90)"
    >
      <g
        id="그룹_65" data-name="그룹 65"
        class="cls-2" transform="translate(0 0)"
      >
        <path
          id="패스_42" data-name="패스 42"
          class="cls-1"
          d="M6.954.155.223,5.579A.576.576,0,0,0,0,6.027V9.643a.605.605,0,0,0,.4.551.737.737,0,0,0,.724-.1L7.4,5.03l6.28,5.061a.733.733,0,0,0,.724.1.606.606,0,0,0,.4-.551V6.027a.582.582,0,0,0-.222-.448L7.855.155a.733.733,0,0,0-.9,0"
          transform="translate(0 0)"
        />
        <path
          id="패스_43" data-name="패스 43"
          class="cls-1"
          d="M6.954.155.223,5.579A.576.576,0,0,0,0,6.027V9.643a.605.605,0,0,0,.4.551.737.737,0,0,0,.724-.1L7.4,5.03l6.28,5.061a.733.733,0,0,0,.724.1.606.606,0,0,0,.4-.551V6.027a.582.582,0,0,0-.222-.448L7.855.155a.733.733,0,0,0-.9,0"
          transform="translate(0 7.834)"
        />
      </g>
    </g>
  </svg>
</template>